import { ScrollableTabs } from '@reveni-io/reveni-ui'

const LanguageTabs = ({ availableLanguages, languageSelected, onChangeLanguage }) => {
  return <ScrollableTabs tabs={availableLanguages} value={languageSelected} onChange={onChangeLanguage} />
}

export default LanguageTabs
